import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React from "react";

const Log = (props) => {
  const { openLogDialog, handleCloseLog, logs } = props;
  return (
    <Dialog
      open={openLogDialog}
      onClose={handleCloseLog}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#f9f9f9",
          color: "#333",
          fontWeight: "bold",
          borderBottom: "1px solid #ddd",
          padding: "8px 16px",
        }}
      >
        Log
      </DialogTitle>
      <DialogContent
        dividers
        sx={{ padding: "12px 16px", backgroundColor: "#fff" }}
      >
        {logs?.length > 0 ? (
          <Box>
            {logs.map((log, index) => (
              <Box
                key={log._id}
                sx={{
                  paddingBottom: 1,
                  marginBottom: 1,
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                <Typography
                  variant="subtitle2"
                  fontWeight="bold"
                  color="primary"
                >
                  Action: {log.action}
                </Typography>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    mt: 0.5,
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography variant="body2" color="textSecondary" mr={1}>
                      <strong>User ID:</strong> {log.userId.userId}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      <strong>User Name:</strong> {log.userId.userName}
                    </Typography>
                  </Box>
                  <Typography variant="caption" color="textSecondary">
                    {new Date(log.createdAt).toLocaleString()}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        ) : (
          <Typography
            variant="body2"
            color="textSecondary"
            textAlign="center"
            sx={{ paddingY: 1 }}
          >
            No logs available.
          </Typography>
        )}
      </DialogContent>
      <DialogActions
        sx={{
          backgroundColor: "#f9f9f9",
          padding: "8px 16px",
          justifyContent: "center",
        }}
      >
        <Button
          onClick={handleCloseLog}
          color="primary"
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 1,
            paddingX: 2,
            paddingY: 0.5,
            "&:hover": {
              backgroundColor: "#1976d2",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.12)",
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Log;
